<template>
<div class="chapter">
<div class="inner_page">
<div id="part1">
<h1><a id="page17"></a><a href="#/007toc#p01">PART 1<br/>Obsessive-Christianity<br/>Disorder</a></h1>
<p class="center"><i>We may spend our days in what we call our religious duties,<br/>and we may fill our devotions with fervor, and still may be miserable.<br/>Nothing can set our hearts at rest but a real acquaintance with God.</i></p>
<p class="center">Hannah Whitall Smith (1832-1911)</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 010part1.vue?c2ff91ea